import { render } from "./form-wrapper.vue?vue&type=template&id=79993966"
const script = {}

const cssModules = {}
import style0 from "./form-wrapper.vue?vue&type=style&index=0&id=79993966&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__